<script>
    import data_raw from "dataset:../_data/turf-chart.json"
    import {format} from 'd3-format'
    import { LayerCake, Svg } from 'layercake';

    import Column from './_components/Column.svelte';
    import Area from './_components/Area.svelte';
    import Line from './_components/Line.svelte';
    import AxisX from './_components/AxisX.svelte';
    import AxisY from './_components/AxisY.svelte';
    
    export let assets;

    const xKey = 'year';
    const yKey_acres = 'acres_rebated';
    const yKey_incentives = 'incentive_per_sqft_cpi';

    var data_acres = data_raw.acres
    var data_incentives = data_raw.incentives

    data_acres.forEach(d => {
        d[xKey] = +d[xKey];
        d[yKey_acres] = +d[yKey_acres];
    });

    data_incentives.forEach(d => {
        d[xKey] = +d[xKey];
        d[yKey_incentives] = +d[yKey_incentives];
    });

</script>

<div class="wrapper center">
    <div class="chart-wrapper">
        <div class="label">
            {assets.label1}
        </div>           
        <div class="chart-container">
            <LayerCake
                padding={{ top: 20, right: 0, bottom: 20, left: 20 }}
                x={xKey}
                y={yKey_acres}
                xDomain={['2000', '2022']}
                yDomain={[0, 800]}
                data={data_acres}
            >
                <Svg>
                <Column/>
                <AxisX
                    gridlines={false}
                    snapTicks={true}
                />
                <AxisY
                    gridlines={false}
                    ticks={[0, 800]}
                    tickLabel="acres"
                    tickLabel2="removed"
                />
                </Svg>
            </LayerCake>
        </div> 
    </div>

    <div class="chart-wrapper">
        <div class="label">
            {assets.label2}
        </div>          
        <div class="chart-container">
            <LayerCake
                padding={{ top: 0, right: 0, bottom: 20, left: 20 }}
                x={xKey}
                y={yKey_incentives}
                xDomain={['2000', '2022']}
                yDomain={[0, 4.8]}
                data={data_incentives}
            >
                <Svg>
                <Area/>
                <Line/>
                <AxisX
                    gridlines={false}
                    snapTicks={true}
                />
                <AxisY
                    gridlines={false}
                    ticks={[0, 4]}
                    tickLabel="per sqft"
                    tickLabel2="removed"
                    formatTick={format("$")}
                />
                </Svg>
            </LayerCake>
        </div> 
    </div>
    {#if assets.caption}
        <div class="caption">{assets.caption}</div>
    {/if}
</div>

<style lang="scss">
    @import "@propublica/pp-v5-shared/src/css/column-setter-and-deps";
    .wrapper {
        margin: var(--spacing0) auto;
        width: 100%;
    }

    .chart-wrapper {
        &:nth-child(2) {
            margin-top: var(--spacing0);
        }
    }

    .chart-container {
        height: 120px;
        width: 100%;
    }

    .label {
        font-family: var(--fonts-sans);
        font-size: var(--scale-1);
        line-height: var(--line-height-2);
        font-weight: 700;
        
        @include breakpoint-max(sm) {
            font-size: var(--scale0);
            max-width: 290px;
        }
    }

    .caption {
        font-size: var(--scale-3)
    }
</style>